export default __webpack_public_path__ + "static/media/carousel-pic-three.4b222dc0.png";